import {
  MenuItem,
  Stack,
  useTheme,
  Popover,
  Typography,
  Divider,
  MenuList,
} from "@mui/material";
import useStyles from "./styles";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import { useEffect, useState } from "react";

dayjs.extend(duration);
const ModalDateTime = ({
  anchorEl,
  setAnchorEl,
  optionsTimesRange,
  value,
  onChange,
  onClose,
  disabled,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const handleClose = () => {
    setAnchorEl(null);
    if (errorInitialDate || errorEndDate) return;
    onClose();
  };
  const [intervalSeleted, setIntervalSelected] = useState();
  const [errorInitialDate, setErrorInitialDate] = useState(null);
  const [errorEndDate, setErrorEndDate] = useState(null);

  const { timeStart, timeEnd } = value || {
    timeStart: dayjs().subtract(24, "hour").toDate(),
    timeEnd: dayjs().toDate(),
    option: null,
  };

  useEffect(() => {
    const autoIntervalSelect = optionsTimesRange.find((option) => {
      const calcIntervl = calculateInterval(option);
      if (
        dayjs(timeStart).startOf("minute").format("YYYY-MM-DD HH:mm:ss") ===
          dayjs(calcIntervl.timeStart)
            .startOf("minute")
            .format("YYYY-MM-DD HH:mm:ss") &&
        dayjs(timeEnd).startOf("minute").format("YYYY-MM-DD HH:mm:ss") ===
          dayjs(calcIntervl.timeEnd)
            .startOf("minute")
            .format("YYYY-MM-DD HH:mm:ss")
      ) {
        return true;
      }
    });

    setIntervalSelected(autoIntervalSelect);
  }, [timeStart, timeEnd]);

  const handleChangeDateTimeStart = (value) => {
    setIntervalSelected(null);
    onChange({
      timeStart: value ? value.toDate() : null,
      timeEnd: timeEnd,
    });
  };

  const handleChangeDateTimeEnd = (value) => {
    setIntervalSelected(null);
    onChange({
      timeStart: timeStart,
      timeEnd: value ? value.toDate() : null,
    });
  };

  const calculateInterval = (option) => {
    if (option.type === "ago")
      return {
        timeStart: dayjs().subtract(option.value, option.unitEn).toDate(),
        timeEnd: dayjs().toDate(),
        option: option,
      };
    if (option.type === "current")
      return {
        timeStart: dayjs().startOf(option.unitEn).toDate(),
        timeEnd: dayjs().toDate(),
        option: option,
      };

    if (option.type === "previous")
      return {
        timeStart: dayjs()
          .startOf(option.unitEn)
          .subtract(1, option.unitEn)
          .toDate(),
        timeEnd: dayjs()
          .endOf(option.unitEn)
          .subtract(1, option.unitEn)
          .toDate(),
        option: option,
      };
    return {
      timeStart: dayjs().subtract(7, "days").toDate(),
      timeEnd: dayjs().toDate(),
    };
  };

  const handleMenuItemClick = (option) => {
    setIntervalSelected(option);
    onChange(calculateInterval(option));
  };

  const textOptions = (option) => {
    if (option.type === "ago") {
      return ` ${option.value} ${option.unit} atrás`;
    }
    if (option.type === "current") {
      return `${option.unit} atual`;
    }
    if (option.type === "previous") {
      return `${option.unit} anterior`;
    }
  };
  return (
    <Popover
      id={"modal-data"}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      sx={styles.paperPoover}
    >
      <>
        <Stack direction="row" spacing={1}>
          <Stack direction="column" spacing={2}>
            <Typography sx={styles.titleDataPicker}>
              Intervalos de tempo absoluto
            </Typography>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={"pt-br"}
            >
              <Stack direction="column" spacing={1}>
                <Stack
                  direction="column"
                  alignItems={"start"}
                  gap={0}
                  justifyContent={"space-between"}
                >
                  <Typography sx={styles.textDataPicker}>
                    Data Inicial
                  </Typography>
                  <DateTimePicker
                    value={dayjs(timeStart)}
                    onChange={(value) => handleChangeDateTimeStart(value)}
                    onError={(newError) => setErrorInitialDate(newError)}
                    slotProps={styles.dataTime}
                    minutesStep={1}
                    minDate={dayjs().subtract(7, "day")}
                    maxDateTime={dayjs(timeEnd)}
                    disabled={disabled}
                  />
                </Stack>
                <Stack
                  direction="column"
                  alignItems={"start"}
                  gap={0}
                  justifyContent={"space-between"}
                >
                  <Typography sx={styles.textDataPicker}>Data Final</Typography>
                  <DateTimePicker
                    slotProps={styles.dataTime}
                    value={dayjs(timeEnd)}
                    onChange={(value) => handleChangeDateTimeEnd(value)}
                    onError={(newError) => setErrorEndDate(newError)}
                    minDateTime={dayjs(timeStart).add(1, "minute")}
                    minutesStep={1}
                    disabled={disabled}
                  />
                </Stack>
              </Stack>
            </LocalizationProvider>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack direction="column" spacing={1}>
            <Typography sx={styles.titleDataPicker}>
              Intervalos de tempo relativo
            </Typography>
            <MenuList sx={styles.menuList}>
              {optionsTimesRange?.map((option) => (
                <MenuItem
                  selected={
                    intervalSeleted
                      ? intervalSeleted.value === option.value &&
                        intervalSeleted.unit === option.unit &&
                        intervalSeleted.unitEn === option.unitEn &&
                        intervalSeleted.type === option.type
                      : false
                  }
                  sx={styles.menuItem}
                  key={option.value + option.unit + option.type + option.unitEn}
                  onClick={() => handleMenuItemClick(option)}
                  disabled={disabled}
                >
                  {textOptions(option)}
                </MenuItem>
              ))}
            </MenuList>
          </Stack>
        </Stack>
      </>
    </Popover>
  );
};

export default ModalDateTime;
